import Fuse from "fuse.js";
import { useMemo } from "react";

interface UseFuseSearchOptions<T> {
  data: T[];
  keys: string[];
  threshold?: number;
}

export const useFuseSearch = <T>({ data, keys, threshold = 0.3 }: UseFuseSearchOptions<T>) => {
  const fuse = useMemo(() => {
    return new Fuse(data, {
      keys,
      threshold,
      ignoreLocation: true,
      useExtendedSearch: true,
      shouldSort: true,
      findAllMatches: true,
    });
  }, [data, keys, threshold]);

  const search = (query: string, tags: string[] = []) => {
    let results = data;

    if (query.trim() !== "") {
      const searchResults = fuse.search(query);
      results = searchResults.map((res) => res.item);
    }

    if (tags.length > 0) {
      results = results.filter((item: any) => tags.every((tag) => item.tags?.includes(tag)));
    }

    return results;
  };

  return { search };
};
